export function useMapSelection(urlKey: string) {
  const selectedId = useUrlSelectedId(urlKey);

  function onMarkerClick(payload: { feature: GeoJSON.Feature }) {
    const id = payload.feature.properties?.id;
    if (!id || payload.feature.geometry.type !== "Point") return;
    selectedId.value = String(id);
  }

  return { selectedId, onMarkerClick };
}
